import { Formik } from "formik";
import { Grid } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";

import FormDisplay from "./FormDisplay";
import SubmitButton from "./SubmitButtons";
import CreateButton from "./CreateButtons";
import validationSchema from "./validationSchema";
import EmailPreview from "./EmailTemplatePreview";

import { useAxios, useComponent } from "./../../../../hooks";
import { objectFromFormData } from "./emailTemplateDetailsObject";
import TemplateBody from "./template body components/TemplateBody";
import TemplateSubject from "./template subject components/TemplateSubject";
import TemplateAttachment from "./template attachment components/TemplateAttachment";
import pages from "../../../../constants/pages";

export default function Form({
  formData,
  templateData,
  agentID,
  language,
  category,
  botDetails,
  pagePermissions,
}) {
  const axios = useAxios();
  const { alert } = useComponent();
  const { activeBot } = useSelector((state) => state.memberDetails);
  const navigation = useNavigate();

  const [addSample, setAddSample] = useState(false);
  const [editState, setEditState] = useState(false);

  return (
    <Formik
      enableReinitialize
      initialValues={formData}
      validationSchema={validationSchema}
      validateOnMount
      onSubmit={(formData, { setSubmitting }) => {
        var data = objectFromFormData(formData);

        axios({
          url:
            "/push_notification/template" +
            (formData.ID ? `/${formData.ID}/` : "") +
            "?agent_id=" +
            activeBot.ID,
          method: !formData.ID ? "POST" : "PATCH",
          disableRedirect: true,
          data: data,
        }).then((response) => {
          if (response.status) {
            alert.success(response.message.displayMessage);

            navigation(pages.pushNotificationTemplateList.route);
          }
          setSubmitting(false);
        });
      }}
    >
      {(formikProps) => (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormDisplay
              formikProps={formikProps}
              templateData={templateData}
              agentID={agentID}
              language={language}
              category={category}
              addSample={addSample}
              botDetails={botDetails}
              pagePermissions={pagePermissions}
              editState={editState}
            />

            <TemplateSubject
              formikProps={formikProps}
              addSample={addSample}
              editState={editState}
            />

            <TemplateBody
              formikProps={formikProps}
              addSample={addSample}
              editState={editState}
            />

            {!formikProps.values.ID && (
              <SubmitButton
                formikProps={formikProps}
                addSample={addSample}
                setAddSample={setAddSample}
              />
            )}

            {!!formikProps.values.ID && (
              <CreateButton
                formikProps={formikProps}
                editState={editState}
                setEditState={setEditState}
              />
            )}
          </Grid>
        </Grid>
      )}
    </Formik>
  );
}
